import React, { memo, SVGProps } from 'react'

export const Download = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.7011 10.7453L12.72 14.7274V4.10016C12.72 3.70272 12.3974 3.38016 12 3.38016C11.6026 3.38016 11.28 3.70272 11.28 4.10016V14.7274L7.29887 10.7453C7.01759 10.464 6.56159 10.464 6.28031 10.7453C5.99903 11.0266 5.99903 11.4826 6.28031 11.7638L11.4912 16.9747C11.5574 17.041 11.6362 17.0928 11.7235 17.1293C11.8109 17.1658 11.905 17.185 12.001 17.185C12.097 17.185 12.191 17.1658 12.2784 17.1293C12.3658 17.0928 12.4445 17.04 12.5107 16.9747L17.7216 11.7638C18.0029 11.4826 18.0029 11.0266 17.7216 10.7453C17.4403 10.464 16.9843 10.464 16.703 10.7453H16.7011Z"
      fill="currentColor"
    />
    <path
      d="M3.55487 19.8998C3.55487 20.2973 3.87743 20.6198 4.27487 20.6198H19.7261C20.1235 20.6198 20.4461 20.2973 20.4461 19.8998C20.4461 19.5024 20.1235 19.1798 19.7261 19.1798H4.27487C3.87743 19.1798 3.55487 19.5024 3.55487 19.8998Z"
      fill="currentColor"
    />
  </svg>
))
